// locales/i18n.js (or wherever your i18n config is)
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./en/translation.json";
import translationAR from "./ar/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "ar", 
    resources: {
      en: { translation: translationEN },
      ar: { translation: translationAR },
    },
    fallbackLng: "ar",
    interpolation: {
      escapeValue: false,
    },
 
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], 
    },
  });

export default i18n;
